import { NavArrowRight12x24Icon } from '@eventbrite/marmalade/icons';
import React from 'react';
import styles from './InlineCTA.module.scss';

export interface InlineCTAProps {
  label: string;
  link: string;
  dataHeapId?: string;
}

export const InlineCTA: React.FunctionComponent<InlineCTAProps> = ({
  label,
  link,
  dataHeapId = 'mlp-webapp-cta-inline',
}) => {
  return (
    <a href={link} className={styles.inline_cta} data-heap-id={dataHeapId}>
      {label}
      <NavArrowRight12x24Icon size="MD" color="var(--marm-color-action-fg-base)" />
    </a>
  );
};
